










































import { namespace } from 'vuex-class';
import { Component, Vue } from 'vue-property-decorator';
import { CART } from '@/store/types';
import { ConfigService } from '@/services/ConfigService';
import { CustomerAddressDto, CustomersApi } from '@eurogast/hub-client-typescript';
import { ApiService } from '@/services/ApiService';

const cart = namespace(CART);

@Component({
  components: {}
})
export default class CustomerInformationRow extends Vue {
  public customerAddress: CustomerAddressDto = null;
  public emailAddresses: string[] = [];

  public mounted() {
    const api = ApiService.wrap(CustomersApi);
    api.getInvoiceAddress(ConfigService.getTenant(), ConfigService.currentCustomerId).then((result) => {
      this.customerAddress = result;
    }).catch(ApiService.defaultErrorHandler);

    api.getConfirmationEmails().then((result) => {
      this.emailAddresses = result;
    }).catch(ApiService.defaultErrorHandler);
  }

  get customerId() {
    return ConfigService.currentCustomerId;
  }
}
